import * as React from 'react'
import { DefaultTheme } from 'styled-components'
import { StoreProps } from '../../../../services/stores/casting.store'
import { geocodingGeodesicDistance } from '../../../../services/utils/geocoding.service'
import { injectTheme } from '../../../../theme'
import SelectableListComponent from '../../../shared/selectable-list.component'

@injectTheme
export default class CastingRequiredPlaceServiceDeliveryLocationComponent extends React.Component<StoreProps & { theme?: DefaultTheme }, never> {
  render () {
    const { store, data: { city, serviceDeliveryLocation } } = this.props

    const sortedLocations = store.getServiceDeliveryLocations()
      .map(sdl => ({ ...sdl, distance: geocodingGeodesicDistance(city, sdl) }))
      .sort((a, b) => a.distance - b.distance)
    
    return <SelectableListComponent
      data={ sortedLocations }
      name="castingServiceDeliveryLocations"
      value={ serviceDeliveryLocation }
      onChange={ val => { store.set({ serviceDeliveryLocation: val }); store.nextFocus({ closeOnMobile: true }) } }
      formatter={ sdl => <span>{ sdl.name } : { sdl.inline_address } <strong style={{ color: this.props.theme.colors.clr_1 }}>{ ` ${sdl.distance} km` }</strong></span> } />
  }
}
